import React, { useState } from "react";
import { Eye, EyeOff, KeyRound } from "lucide-react";

/**
 * PasswordField — password input with show/hide toggle.
 * Props:
 *  - value, onChange, required, minLength, placeholder, testid
 *  - withIcon: if true, shows a key icon on the left (used on reset page)
 *  - autoComplete: e.g. "current-password" or "new-password"
 */
export const PasswordField = ({
  value,
  onChange,
  required = true,
  minLength = 0,
  placeholder = "",
  testid,
  withIcon = false,
  autoComplete = "current-password",
}) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      {withIcon && (
        <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A0AEC0] pointer-events-none" />
      )}
      <input
        type={visible ? "text" : "password"}
        required={required}
        minLength={minLength || undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        placeholder={placeholder}
        data-testid={testid}
        className={`w-full bg-[#FDFBF7] border-2 border-[#1A2A40]/20 rounded-xl py-3 pr-12 ${withIcon ? "pl-10" : "pl-4"} focus:outline-none focus:border-[#E94A3F]`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-[#A0AEC0] hover:text-[#1A2A40] transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordField;
